import { render, staticRenderFns } from "./KnowDetail.vue?vue&type=template&id=054e2fb8&scoped=true"
import script from "./KnowDetail.vue?vue&type=script&lang=js"
export * from "./KnowDetail.vue?vue&type=script&lang=js"
import style0 from "./KnowDetail.vue?vue&type=style&index=0&id=054e2fb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054e2fb8",
  null
  
)

export default component.exports